<template>
  <div class="component-form-wizard-navigation-bar" :class="{ 'is-sticky': insideStickyBlock }">
    <div class="component-form-wizard-navigation-bar__left">
      <!-- <div>{{ currentStepFull.key }}</div> -->
      <button
        v-if="onPrevious && currentStepFull && currentStepFull.key !== 'scout_terms'"
        class="btn btn-outline"
        :disabled="buttonPreviousDisabled"
        @click="onPrevious"
      >
        {{ buttonPreviousText }}
      </button>
      <div v-else></div>
    </div>
    <div class="component-form-wizard-navigation-bar__center">
      <slot name="text">
        <div v-show="!hideSteps">
          <span class="text-gray-600 px-4">Step</span> {{ currentStep }}
          <span class="text-gray-600 px-4">of</span>
          {{ totalSteps }}
        </div>
      </slot>
    </div>
    <div class="component-form-wizard-navigation-bar__right">
      <button
        v-if="onPrevious && currentStepFull && currentStepFull.key === 'scout_terms'"
        class="btn"
        style="margin-right: 0.5rem; color:#4440DB; background-color: #E3E3FA"
        :disabled="buttonPreviousDisabled"
        @click="onPrevious"
      >
        {{ buttonPreviousText }}
      </button>
      <button
        v-if="onNext && currentStepFull && currentStepFull.key === 'share' && isCustomNextAvailable"
        style="margin-right: 1rem;"
        :class="[
          'btn',
          {
            disabled: buttonNextDisabled
          }
        ]"
        @click="debouncedOnCustomNext"
      >
        <span v-if="!buttonNextLoading">{{ buttonCustomNextText }}</span>
        <!-- <span v-if="!buttonNextLoading">{{ buttonNextText }}</span> -->
        <b-spinner v-else small />
      </button>
      <button
        v-if="onNext"
        :class="[
          'btn',
          {
            disabled: buttonNextDisabled
          }
        ]"
        @click="debouncedOnNext"
      >
        <span v-if="!buttonNextLoading">{{ buttonNextText }}</span>
        <!-- <span v-if="!buttonNextLoading">{{ buttonNextText }}</span> -->
        <b-spinner v-else small />
      </button>
    </div>
    <div v-show="!hideProgressBar" class="component-form-wizard-navigation-bar__progress">
      <ProgressBar :progress="progress" />
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar';
import debounce from 'lodash/debounce';

export default {
  name: 'FormWizardNavigationBar',
  components: { ProgressBar },
  props: {
    hideText: Boolean,
    hideSteps: {
      type: Boolean,
      default: false
    },
    hideProgressBar: {
      type: Boolean,
      default: false
    },
    insideStickyBlock: {
      type: Boolean,
      default: false
    },
    buttonNextText: {
      type: String,
      default: 'Next'
    },
    buttonCustomNextText: {
      type: String,
      default: 'Next'
    },
    buttonPreviousText: {
      type: String,
      default: 'Previous'
    },
    buttonNextLoading: Boolean,
    buttonNextDisabled: Boolean,
    buttonPreviousDisabled: Boolean,
    onNext: Function,
    onCustomNext: Function,
    isCustomNextAvailable: {
      type: Boolean,
      default: false
    },
    onPrevious: Function,
    currentStep: {
      type: Number,
      required: true
    },
    currentStepFull: {
      type: Object,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    },
    selectedProduct: {
      type: Object,
      required: false
    }
  },
  computed: {
    progress() {
      return this.currentStep / this.totalSteps;
    }
  },
  methods: {
    debouncedOnNext: debounce(
      async function() {
        // console.log('help2')
        await this.onNext();
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    debouncedOnCustomNext: debounce(
      async function() {
        // console.log('help2')
        await this.onCustomNext();
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    )
  }
};
</script>

<style lang="scss">
// StickyBlock (For /profile-settings Digest page)
.sticky-block__content {
  .component-form-wizard-navigation-bar {
    @media (max-width: 576px) {
      padding: rem(15px) 0;
    }
  }
}

.sticky-block__content.sticky-block__content--sticky {
  .component-form-wizard-navigation-bar {
    padding: 0rem (15px);
    @media (max-width: 576px) {
      padding: rem(15px);
    }
  }
}

.component-form-wizard-navigation-bar {
  position: relative;
  height: $footer-height;
  display: flex;
  padding: 0 20px;
  align-items: center;
  border-top: 1px solid $border-color;

  &.is-sticky {
    @include media-breakpoint-down(sm) {
      padding: rem(15px);
    }
    @include media-breakpoint-up(md) {
      padding: 0 rem(15px);
    }
  }

  &__left,
  &__center,
  &__right {
    display: flex;
    align-items: center;
  }

  &__center {
    justify-content: center;
    flex: 1;
  }

  &__right {
    justify-content: flex-end;
  }

  &__progress {
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
  }

  button {
    padding: 0;
    width: 160px;

    @include media-breakpoint-down(sm) {
      width: 100px;
    }
  }

  @include media-breakpoint-down(xs) {
    height: 100%;
  }
}
</style>
